import {Component, OnInit, SecurityContext, ViewChild, Output, EventEmitter} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../../api.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {LinksComponent} from '../links.component';
import {HttpClient} from '@angular/common/http';
import {DomSanitizer} from '@angular/platform-browser';
import {TagsComponent} from '../../tags/tags.component';
import {MessageService} from '../../message.service';
import { Message, MessageTypes } from '../../message';

@Component({
  selector: 'app-edit-link',
  templateUrl: './edit-link.component.html',
  styleUrls: ['./edit-link.component.css']
})
export class EditLinkComponent implements OnInit {
    private id: any;
    private editForm: FormGroup;

    @ViewChild(TagsComponent)
    protected tagsComponent: TagsComponent;

    @Output() message = new EventEmitter<Message>();
    link: any;
    imagesLoading = false;
    images = [];
    selectedImage: string;
    title = 'New link ';
    tags: string[] = [];
    domain: string;
    state;
    submitLabel: string;

    constructor(
        protected apiService: ApiService,
        protected router: Router,
        protected linksComponent: LinksComponent,
        protected http: HttpClient,
        protected sanitizer: DomSanitizer,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        protected messageService: MessageService
    ) {
        this.domain = document.location.protocol + '//' + document.location.host;

        this.editForm = this.formBuilder.group({
          id: '', /* der Wert '' ist der Default-Wert */
          url: '',
          title: '',
          tags: []
      });
      this.link = {id: 0, url: '', title: '', tags: []};
  }

  ngOnInit() {
      const id = this.route.snapshot.paramMap.get('id');
      this.state = '';
      this.submitLabel = 'save';
      this.title = 'New link';
      if (id) {
          this.title = 'Edit link';
          this.id = id;
          this.state = 'loading';
          this.submitLabel = 'loading';
          this.loadLink();
      }
  }

  loadLink() {
      this.apiService.getById('links', this.id).subscribe(
          (value) => {
              this.link = value;
              this.tagsComponent.tags = this.link.tags;
              this.state = '';
              this.getScreenshot();
              this.submitLabel = 'update';
          }, (error) => {
              this.state = '';
              this.submitLabel = 'update';
          }
      );
  }

    public getScreenshot() {
        this.imagesLoading = true;
        this.images = [];
        this.http.get('/api/links/screenshot?url=' + encodeURI(this.link.url))
            .subscribe((value) => {
                this.imagesLoading = false;
                this.images = new Array();//this.domain + '/api/links/screenshot/' + this.removeProtocol(this.link.url));
                const images = <string[]>value;
                images.forEach((image) => {
                    // this.images.push(this.sanitizer.bypassSecurityTrustUrl(image));
                    this.images.push(this.sanitizer.bypassSecurityTrustUrl(image));
                });
            });
    }

    protected removeProtocol(url) {
        return url.replace(/https?:\/\//, '');
    }

    public selectImage(image: string) {
        this.selectedImage = image;
    }

    submit() {
        this.state = 'saving';
        this.submitLabel = 'saving';
        this.link.tags = this.tagsComponent.tags;
        // console.log('calling submit with: ', this.link);
        const uploadData = new FormData();
        if (this.link['uploadFile']) {
            uploadData.append('uploadedimage', this.link['uploadFile'], this.link['uploadFile']['name']);
        }
        const selectedImage = this.sanitizer.sanitize(SecurityContext.URL, this.selectedImage);
        uploadData.append('url', this.link.url);
        uploadData.append('title', this.link.title);
        uploadData.append('tags', this.link.tags.join(','));
        if (selectedImage) {
            uploadData.append('image', selectedImage);
        }
        // todo: validate form - url must be filled
        if (this.id) {
            this.apiService.put('links', this.id, uploadData)
                .subscribe(
                    (value: any) => {
                        this.state = '';
                        this.messageService.setMessage('Link got updated', MessageTypes.Success);
                        this.submitLabel = 'update';
                    },
                    (err) => {
                        this.state = '';
                        this.messageService.setMessage('An error occurred - the link didn`t get updated', MessageTypes.Error);
                        this.submitLabel = 'update';
                    });
        } else {
            this.apiService.post('links', uploadData)
                .subscribe(
                    (value: any) => {
                        this.state = '';
                        this.messageService.setMessage('Link got saved', MessageTypes.Success);
                        this.router.navigate(['/links/list']);
                    },
                    (err) => {
                        this.state = '';
                        this.messageService.setMessage('An error occurred - the link didn`t get saved', MessageTypes.Error);
                        this.submitLabel = 'save';
                    });
        }

    }
    public previewImage(event) {
        const reader = new FileReader();
        reader.onload = function() {
            const output = <HTMLImageElement>document.getElementById('upload-preview');
            output.src = reader.result;
        };
        reader.readAsDataURL(event.target.files[0]);
        this.link['uploadFile'] = event.target.files[0];
        this.selectedImage = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/links/edit-link/edit-link.component.ts